module.exports = __webpack_public_path__ + "static/media/hero-image.34771a56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/hero-image.jpg
// module id = 411
// module chunks = 0